<template>
<div>
    <div v-if="!loading">
        <div>
            <b-button @click="save()" size="sm" class="float-right ml-md-2" variant="success">
                <span v-if="!sending">　保存　</span>
                <span v-if="sending"><i class="fas fa-spinner fa-spin"></i> 送信中</span>
            </b-button>
            <a onclick="return confirm('変更は取り消されます。よろしいですか？')" :href="'/total/working_hours/?user='+monthObj.user.username" class="btn btn-sm btn-danger float-right">キャンセル</a>
            <h3 class="">
                編集
            </h3>
        </div>
        <table class="table table-sm table-working-hours table-bordered table-striped" style="font-size: 10pt; border: 1px solid #777; margin-top:20px; width: 100%">
            <thead style="border-bottom: 2px solid #777">
                <tr>
                    <td class="text-center" width="140" style="width: 100px !important; background-color: #fff7e6" colspan="3">
                        <strong>
                            {{monthObj.the_month}}
                        </strong>
                    </td>
                    <td class="text-center">所属</td>
                    <td class="text-right" colspan="4">{{monthObj.user.group.name}} グループ</td>
                    <td colspan="3">氏名：{{monthObj.user.name}} </td>
                    <td colspan="2"></td>
                </tr>
                <tr>
                    <td width="30" class="text-center align-middle" rowspan="2">日付</td> 
                    <td width="140" class="text-center align-middle" style="background-color: #ffff99; width: 100px !important" colspan="2">労働時間</td>
                    <td width="50" class="text-center align-middle" style="background-color: #fff7e6" rowspan="2">在社時間</td>
                    <td width="" class="text-center align-middle" style="background-color: #ffff99" rowspan="2">休憩（H）</td>
                    <td width="" class="text-center align-middle" style="background-color: #fff7e6" rowspan="2">実労時間</td>
                    <td width="" class="text-center align-middle" style="background-color: #ffff99" rowspan="2">通常勤 時間帯</td>
                    <td width="180" class="text-center align-middle" style="background-color: #ffff99; width: 150px !important" rowspan="2">
                        <div style="width: 110px !important">
                            深夜勤<br>時間帯<br>22:00 ~ 5:00
                        </div>
                    </td>
                    <td width="" class="text-center align-middle" style="background-color: #ffff99" rowspan="2">時間外勤</td>
                    <td width="" class="text-center align-middle" style="background-color: #ffff99" rowspan="2">休日出勤</td>
                    <td width="" class="text-center align-middle" style="background-color: #ffff99" rowspan="2">有給時間</td>
                    <td width="500" class="text-center align-middle" style="background-color: #ffff99" rowspan="2" colspan="2">
                        作業内容<br>
                        振替、代休、休日出勤
                    </td>
                </tr>
                <tr>
                    <td width="" class="text-center" style="background-color: #ffff99">出社</td>
                    <td width="70" class="text-center" style="background-color: #ffff99">退社</td>
                </tr>
            </thead>
            <tbody class="text-center">
                <!-- @foreach (monthObj.days as day) -->
                    <tr v-for="(day, index) in monthObj.days" :key="day.number">
                        <td :class="{'text-danger':day.is_holiday,'text-center':true}">{{day.number}}</td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('start_hour',index+1)"
                                v-on:keyup.down="jumpTo('start_hour',index+1)"
                                v-on:keyup.up="jumpTo('start_hour',index-1)"
                                ref="start_hour"
                                class="sb-cell text-center"
                                debounce="1000"
                                v-model="day.startHour"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('end_hour',index+1)"
                                v-on:keyup.down="jumpTo('end_hour',index+1)"
                                v-on:keyup.up="jumpTo('end_hour',index-1)"
                                ref="end_hour"
                                class="sb-cell text-center"
                                debounce="1000"
                                v-model="day.endHour"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('timeInCompany',index+1)"
                                v-on:keyup.down="jumpTo('timeInCompany',index+1)"
                                v-on:keyup.up="jumpTo('timeInCompany',index-1)"
                                ref="timeInCompany"
                                class="sb-cell"
                                @blur="calculate(day, 'timeInCompany')"
                                debounce="1000"
                                v-model="day.timeInCompany"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('nippou.breaktime',index+1)"
                                v-on:keyup.down="jumpTo('nippou.breaktime',index+1)"
                                v-on:keyup.up="jumpTo('nippou.breaktime',index-1)"
                                ref="nippou.breaktime"
                                class="sb-cell"
                                @blur="calculate(day, 'nippou.breaktime')"
                                debounce="1000"
                                v-model="day.nippou.breaktime"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('totalTime',index+1)"
                                v-on:keyup.down="jumpTo('totalTime',index+1)"
                                v-on:keyup.up="jumpTo('totalTime',index-1)"
                                ref="totalTime"
                                class="sb-cell"
                                @blur="calculate(day, 'totalTime')"
                                debounce="1000"
                                v-model="day.totalTime"
                            >
                            </b-form-input>
                                <!-- @blur="calculate(day, 'totalTime')" -->
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('normalTime',index+1)"
                                v-on:keyup.down="jumpTo('normalTime',index+1)"
                                v-on:keyup.up="jumpTo('normalTime',index-1)"
                                ref="normalTime"
                                class="sb-cell"
                                @blur="calculate(day, 'normalTime')"
                                debounce="1000"
                                v-model="day.normalTime"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('nippou.overnightTime',index+1)"
                                v-on:keyup.down="jumpTo('nippou.overnightTime',index+1)"
                                v-on:keyup.up="jumpTo('nippou.overnightTime',index-1)"
                                ref="nippou.overnightTime"
                                class="sb-cell"
                                @blur="calculate(day, 'nippou.overnightTime')"
                                debounce="1000"
                                v-model="day.nippou.overnightTime"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('overtime',index+1)"
                                v-on:keyup.down="jumpTo('overtime',index+1)"
                                v-on:keyup.up="jumpTo('overtime',index-1)"
                                ref="overtime"
                                class="sb-cell"
                                @blur="calculate(day, 'overtime')"
                                debounce="1000"
                                v-model="day.overtime"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('holidayWorkTime',index+1)"
                                v-on:keyup.down="jumpTo('holidayWorkTime',index+1)"
                                v-on:keyup.up="jumpTo('holidayWorkTime',index-1)"
                                ref="holidayWorkTime"
                                class="sb-cell"
                                @blur="calculate(day, 'holidayWorkTime')"
                                debounce="1000"
                                v-model="day.holidayWorkTime"
                            >
                            </b-form-input>
                        </td>
                        <td>
                            <b-form-input autocomplete="off"
                                v-on:keyup.shift.enter="jumpTo('paidDayoffTime',index+1)"
                                v-on:keyup.down="jumpTo('paidDayoffTime',index+1)"
                                v-on:keyup.up="jumpTo('paidDayoffTime',index-1)"
                                ref="paidDayoffTime"
                                class="sb-cell"
                                @blur="calculate(day, 'paidDayoffTime')"
                                debounce="1000"
                                v-model="day.paidDayoffTime"
                            >
                            </b-form-input>
                        </td>
                        <td v-b-modal="'work-content-modal-'+day.number" colspan="2" style="font-size:6pt">
                            {{ day.applicationWorkContent }}
                            <b-modal title="作業内容" :id="'work-content-modal-'+day.number" hide-footer>
                                <div class="text-right"> {{ dayFormat(day.date) }} </div>
                                <b-form-textarea autocomplete="off" v-model="day.applicationWorkContent" rows="5">
                                </b-form-textarea>
                            </b-modal>
                        </td>
                    </tr>
                <!-- @endforeach -->
            </tbody>
            <tfoot class="text-center" style="border-top: 2px solid #777">
                <tr>
                    <td id="A38" title="A38" colspan="3">合計</td>
                    <td id="D38" title="D38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumTimeInCompany"></b-form-input>
                    </td>
                    <td id="E38" title="E38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumBreaktime"></b-form-input>
                    </td>
                    <td id="F38" title="F38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumTotalTime"></b-form-input>
                    </td>
                    <td id="G38" title="G38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumNormalTime"></b-form-input>
                    </td>
                    <td id="H38" title="H38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumOvernightTime"></b-form-input>
                    </td>
                    <td id="H38" title="H38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumOvertime"></b-form-input>
                    </td>
                    <td id="I38" title="I38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumHolidayWorkTime"></b-form-input>
                    </td>
                    <td id="J38" title="J38" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumPaidDayoffTime"></b-form-input>
                    </td>
                    <td id="K38" title="K38" colspan="2">残業</td>
                </tr>
                <tr>
                    <td id="A39" title="A39" colspan="3">割増時間</td>
                    <td id="D39" title="D39">-</td>
                    <td id="E39" title="E39">-</td>
                    <td id="F39" title="F39" style="background-color: #cce0ff">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.multiplyTotalTime"></b-form-input>
                    </td>
                    <td id="G39" title="G39">-</td>
                    <td id="H39" title="H39" style="background-color: #cce0ff">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.multiplyOvernightTime"></b-form-input>
                    </td>
                    <td id="H39" title="H39" style="background-color: #cce0ff">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.multiplyOvertime"></b-form-input>
                    </td>
                    <td id="I39" title="I39" style="background-color: #cce0ff">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.multiplyHolidayWorkTime"></b-form-input>
                    </td>
                    <td id="J39" title="J39">-</td>
                    <td id="K39" title="K39">割増合計</td>
                    <td id="L39" title="L39" class="text-right" style="background-color: #cce0ff">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumMultipliers"></b-form-input>
                    </td>
                </tr>
                <tr>
                    <td id="A40" title="A40" colspan="2">当月総労働時間</td>
                    <td id="C40" title="C40" style="background-color: #d6f5d6">
                        <b-form-input @blur="sumTotalWorkHours()" autocomplete="off" class="sb-cell" v-model="monthObj.workingHour.hours"></b-form-input>
                    </td>
                    <td id="D40" title="D40" colspan="4" rowspan="2">
                        <strong>Meal allowance</strong> <br>
                        平日：連続　11.0H で１回<br>
                        休日：連続　4.0H で１回
                    </td>
                    <td id="G40" title="G40">昼</td>
                    <td id="H40" title="H40" class="text-right" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell"></b-form-input>
                    </td>
                    <td id="I40" title="I40">前月繰越</td>
                    <td id="J40" title="J40" class="text-right" style="background-color: #d6f5d6">
                        <b-form-input @blur="sumTotalWorkHours()" autocomplete="off" class="sb-cell" v-model="monthObj.previousCarryOver"></b-form-input>
                    </td>
                    <td id="K40" title="K40">次月繰越</td>
                    <td id="L40" title="L40" class="text-right">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.carryOver"></b-form-input>
                    </td>
                </tr>
                <tr>
                    <td id="A41" title="A41" colspan="2">
                        <!-- 標準労働時間 -->
                    </td>
                    <td id="C41" title="C41">
                        <!-- <b-form-input autocomplete="off" class="sb-cell" v-model="monthObj.workingHour.days"></b-form-input> -->
                    </td>
                    <td id="G41" title="G41">夜</td>
                    <td id="H41" title="H41" class="text-right" style="background-color: #fff7e6">
                        <b-form-input autocomplete="off" class="sb-cell"></b-form-input>
                    </td>
                    <td id="I41" title="I41">当月労働時間合計</td>
                    <td id="J41" title="J41" class="text-right" style="background-color: #d6f5d6">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.sumTotalWorkHours"></b-form-input>
                    </td>
                    <td id="K41" title="K41">当月時間外</td>
                    <td id="L41" title="L41" class="text-right">
                        <b-form-input autocomplete="off" class="sb-cell" readonly v-model="monthObj.totalOvertime"></b-form-input>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div v-if="loading" class="border text-center" style="padding: 150px 20px;">
        <i class="fas fa-spinner fa-pulse fa-5x"></i>
    </div>
</div>
</template>

<script>
    import moment from 'moment'
    export default {
        data: function() {
            return {
                title: '勤務時間表',
                url: '',
                loading: false,
                sending: false,
                monthObj: {
                    days: [],
                    user: {
                        group: {}
                    },
                    workingHour: {}
                }
            }
        },
        props: {
            report_id: String
        },
        beforeMount(){
            this.loading = true
        },
        methods: {
            numberFormat(num,decimals) {
                let exp = Math.pow(10,decimals)
                return (Math.round(num * exp) / exp).toFixed(decimals)
            },
            dayFormat(date) {
                var day = moment(date)

                return day.format('YYYY年MM月DD日')
            },
            log(object) {
                console.log('logged', object)
            },
            jumpTo(type, index) {
                this.$nextTick(() => {
                    if (index >= 0) {
                        let collection = this.$refs[type]
                        let input = collection[index];
                        if(input) {
                            input.focus();
                            input.select();
                        }
                    }
                });
            },
            getCellValue(object,cell, toFixed = 2) {
                if(object[cell]!=null && !isNaN(object[cell])) {
                    let cellValue = parseFloat(object[cell])
                    if (isNaN(cellValue)) {
                        cellValue = 0.00
                    }
                    object[cell] = this.numberFormat(cellValue,toFixed)
                    return cellValue
                }
                if(isNaN(object[cell])) {
                    object[cell] = null
                }
                return 0.00
            },
            calculateDayTotalTime(dayObj, field) {
                // trello #27 - 勤務時間：実労働時間の計算式空にする
                return
            },
            calculate(dayObj, field) {
                var value = 0.00
                for (let day of this.monthObj.days) {
                    var fields = field.split('.')
                    if (fields.length==1) {
                        value += this.getCellValue(day,fields[0])
                    } else if (fields.length==2) {
                        value += this.getCellValue(day[fields[0]],fields[1])
                    }
                }
                switch (field) {
                    case 'timeInCompany':
                        this.monthObj.sumTimeInCompany = this.numberFormat(value,2)
                        break;
                    case 'nippou.breaktime':
                        this.monthObj.sumBreaktime = this.numberFormat(value,2)
                        break;
                    case 'totalTime':
                        this.monthObj.sumTotalTime = this.numberFormat(value,2)
                        this.multiplyTotalTime()
                        this.totalOvertime()
                        this.carryOver()
                        break;
                    case 'normalTime':
                        this.monthObj.sumNormalTime = this.numberFormat(value,2)
                        this.calculateDayTotalTime(dayObj, field)
                        break;
                    case 'nippou.overnightTime':
                        this.monthObj.sumOvernightTime = this.numberFormat(value,2)
                        this.multiplyOvernightTime()
                        this.calculateDayTotalTime(dayObj, field)
                        break;
                    case 'overtime':
                        this.monthObj.sumOvertime = this.numberFormat(value,2)
                        this.multiplyOvertime()
                        this.calculateDayTotalTime(dayObj, field)
                        break;
                    case 'holidayWorkTime':
                        this.monthObj.sumHolidayWorkTime = this.numberFormat(value,2)
                        this.multiplyHolidayWorkTime()
                        this.calculateDayTotalTime(dayObj, field)
                        break;
                    case 'paidDayoffTime':
                        this.monthObj.sumPaidDayoffTime = this.numberFormat(value,2)
                        this.calculateDayTotalTime(dayObj, field)
                        break;
                }
            },
            afterSumTotalTime() {

            },
            multiplyTotalTime() {
                // cell F39
                // =SE(0<F38-I38-J41;(F38-I38-J41)*0.25;0)
                let F38 = this.monthObj.sumTotalTime;
                let I38 = this.monthObj.sumHolidayWorkTime;
                let J41 = this.monthObj.sumTotalWorkHours;
                let X38 = this.monthObj.sumTotalWorkHours;

                if (F38 - I38 - J41 > 0) {
                    this.monthObj.multiplyTotalTime = this.numberFormat((F38 - I38 - J41) * 0.25,3);
                } else {
                    this.monthObj.multiplyTotalTime = '0.000';
                }
                this.sumMultipliers()
            },
            multiplyOvernightTime()
            {
                // cell H39
                this.monthObj.multiplyOvernightTime = this.numberFormat((this.monthObj.sumOvernightTime * 0.25),3)
                this.sumMultipliers()
            },
            multiplyOvertime()
            {
                // cell X39
                this.monthObj.multiplyOvertime = this.numberFormat((this.monthObj.sumOvertime * 0.25),3)
                this.sumMultipliers()
            },
            multiplyHolidayWorkTime()
            {
                // cell I39
                this.monthObj.multiplyHolidayWorkTime = this.numberFormat((this.monthObj.sumHolidayWorkTime * 0.35),3)
                this.sumMultipliers()
            },
            sumMultipliers()
            {
                // cell L39
                // =SOMA(F39:J39+X39)

                let F39 = parseFloat(this.monthObj.multiplyTotalTime)
                let H39 = parseFloat(this.monthObj.multiplyOvernightTime)
                let I39 = parseFloat(this.monthObj.multiplyHolidayWorkTime)
                let X39 = parseFloat(this.monthObj.multiplyOvertime)

                this.monthObj.sumMultipliers = this.numberFormat((F39+H39+I39+X39),3)
            },
            carryOver() {
                // cell L40
                // =SE(C40-F38+I38>0;C40-F38;0)
                let C40 = this.getCellValue(this.monthObj.workingHour,'hours')
                let F38 = this.getCellValue(this.monthObj,'sumTotalTime')
                let I38 = this.getCellValue(this.monthObj,'sumHolidayWorkTime')

                if (C40 - F38 + I38 > 0) {
                    this.monthObj.carryOver = this.numberFormat((C40 - F38),2);
                } else {
                    this.monthObj.carryOver = '0.00';
                }

            },
            sumTotalWorkHours()
            {
                // cell J41
                // =C40+J40
                let C40 = this.getCellValue(this.monthObj.workingHour,'hours',0)
                let J40 = this.getCellValue(this.monthObj,'previousCarryOver')

                this.monthObj.sumTotalWorkHours = this.numberFormat((C40 + J40),2);
                this.totalOvertime()
                this.carryOver()
            },
            totalOvertime() {
                // cell L41
                // =SE(F38-J41>0;F38-J41;0)
                let F38 = this.getCellValue(this.monthObj,'sumTotalTime');
                let J41 = this.getCellValue(this.monthObj,'sumTotalWorkHours');

                if (F38 - J41 > 0) {
                    this.monthObj.totalOvertime = this.numberFormat((F38 - J41),2);
                } else {
                    this.monthObj.totalOvertime = '0.00';
                }
            },
            save() {
                if (this.sending) {
                    return false
                }
                this.sending = true
                window.axios.put(this.url, {monthObj: this.monthObj}).then(({ data }) => {
                    this.makeToast('保存しました。')
                }).catch((response) => {
                    console.log(response)
                }).finally(()=>{
                    this.sending = false
                })
            },
            getMonth() {
                this.loading = true
                window.axios.get(this.url).then(({ data }) => {
                    this.monthObj = data.monthObj
                }).catch((response) => {
                    console.log(response)
                }).finally(()=>{
                    this.loading = false
                })
            },
            makeToast(msg = '', variant = 'success',title = this.title, append = false) {
                this.$bvToast.toast(msg, { variant: variant, title: title, autoHideDelay: 5000, appendToast: append })
            }
        },
        created() {
            this.url = `/api/report/${this.report_id}`
            this.getMonth()
        }
    }
</script>
